/* eslint-disable @typescript-eslint/no-explicit-any */
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import React from "react";
import { ReactComponent as IconEdit } from "../../../../../shared/assets/Icons/Icon_Edit.svg";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { withFallback } from "kontrolEdge/helpers/formattersShappedData";
import type { ResourceTagSummary } from "kontrolEdge/components/Shared/NameTagEdit/useResourceTags";
import { mapKeListResourceTags } from "kontrolEdge/components/Shared/mapKeListResourceTags";

export interface HostConfig {
	host: string;
	pve_host: string;
}

export interface TenantInfo {
	id: number;
	Name: string;
	nameDisplay: string;
}

export interface Fwaas {
	id: number;
	tenantId: number;
	name: string;
	subscriptionId: string;
	terms: number | null;
	autoRenew: boolean | null;
	connections: string;
	hostConfigs: HostConfig[];
	isDraft: boolean;
	odooMetadata: any | null;
	createdAt: string;
	updatedAt: string;
	tenant: TenantInfo | null;
	/** Rich pivot tags from TaggedResources (§5.5). */
	tagsRich?: ResourceTagSummary[];
}

export const columns: GenericTableColumn<Fwaas>[] = [
	{
		header: "ID",
		accessor: "id",
	},
	{
		header: "Name",
		accessor: "name",
	},
	{
		header: "Subscription ID",
		accessor: "subscriptionId",
	},
	{
		header: "Tenant",
		renderCell: (row) => row.tenant?.nameDisplay || row.tenant?.Name || "-",
	},
	{
		header: "Status",
		renderCell: (row) => {
			const isDraft = row.isDraft;
			let variant: "success" | "default" | "error" | "warning";
			let label: string;

			if (isDraft === false) {
				variant = "success";
				label = "Active";
			} else if (isDraft === true) {
				variant = "warning";
				label = "Draft";
			} else {
				variant = "default";
				label = "Unknown";
			}
			return <GenericTag variant={variant} label={label} size="small" />;
		},
	},
	{
		header: "Connections",
		accessor: "connections",
	},
	{
		header: "Actions",
		accessor: "id",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View fwaas:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit fwaas:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>

				{/* Delete Button */}
				{/* <button
					className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
					onClick={() => {
						console.log("Delete fwaas:", row);
					}}
				>
					<IconDelete className="w-5 h-5" />
				</button> */}
			</div>
		),
	},
];

export const shapeFwaasData = (rows: any[]): Fwaas[] =>
	rows.map((r) => {
		const tagsRich = mapKeListResourceTags(r);
		return {
			id: Number(r.id),
			tenantId: Number(r.tenantId) || 0,
			name: withFallback(r.name),
			subscriptionId: withFallback(r.subscriptionId),
			terms: r.terms ? Number(r.terms) : null,
			autoRenew: r.autoRenew !== null && r.autoRenew !== undefined ? Boolean(r.autoRenew) : null,
			connections: withFallback(r.connections),
			hostConfigs: Array.isArray(r.hostConfigs) ? r.hostConfigs.map((hc: any) => ({
				host: withFallback(hc.host),
				pve_host: withFallback(hc.pve_host),
			})) : [],
			isDraft: Boolean(r.isDraft),
			odooMetadata: r.odooMetadata || null,
			createdAt: r.createdAt ? String(r.createdAt) : "",
			updatedAt: r.updatedAt ? String(r.updatedAt) : "",
			tenant: r.tenant ? {
				id: Number(r.tenant.id) || 0,
				Name: withFallback(r.tenant.Name),
				nameDisplay: withFallback(r.tenant.nameDisplay),
			} : null,
			tagsRich,
		};
	});
